import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { PublicHeader, Wordmark } from "../components/PublicHeader";
import { api, formatApiError } from "../lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) return toast.error("Passwords don't match");
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: password });
      toast.success("Password updated — sign in with your new password");
      navigate("/signin");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  const inputCls = "mt-1.5 w-full rounded-lg border border-[#e3e0d3] px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#94a01a]";

  return (
    <div className="min-h-screen bg-[#f5f3ee]">
      <PublicHeader />
      <div className="pt-16 min-h-screen flex items-center justify-center px-6 py-16">
        <div className="w-full max-w-md bg-white rounded-lg border border-[#e3e0d3] p-8 sm:p-10" data-testid="reset-password-page">
          <Wordmark />
          <h1 className="text-2xl font-bold text-[#0d2f4d] tracking-tight mt-6">Set a new password</h1>
          {!token ? (
            <p className="text-sm text-[#51637a] mt-4" data-testid="reset-no-token">
              This reset link is invalid or incomplete. <Link to="/forgot-password" className="text-[#7C8514] font-medium hover:underline">Request a new one</Link>.
            </p>
          ) : (
            <form onSubmit={submit} className="mt-8 space-y-5">
              <div>
                <label className="text-xs uppercase tracking-[0.15em] font-medium text-[#51637a]">New password (min 8 characters)</label>
                <input type="password" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)}
                  data-testid="reset-password-input" className={inputCls} />
              </div>
              <div>
                <label className="text-xs uppercase tracking-[0.15em] font-medium text-[#51637a]">Confirm new password</label>
                <input type="password" required minLength={8} value={confirm} onChange={(e) => setConfirm(e.target.value)}
                  data-testid="reset-confirm-input" className={inputCls} />
              </div>
              <button type="submit" disabled={busy} data-testid="reset-submit-button"
                className="w-full rounded-full bg-[#0d2f4d] text-white font-medium py-3.5 hover:bg-[#1c4d78] transition-colors disabled:opacity-60">
                {busy ? "Updating..." : "Update password"}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
